module.exports = __webpack_public_path__ + "img/form_steps_icon_success.31db39a6.svg";